// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1qLqI","requiredAsterisk":"Info_requiredAsterisk__3Mfzb"};